window.URL_API = 'https://api.k8s.sprinta.com.br/'
// window.URL_API = 'https://api.sprinta.com.br/'
window.adyen_public_api = "10001|B2D02C75AD12FC538242B447AF0AAC33A470DCB2B278FDB7F8B1D252BEBC1F86F3EE506A6AC6F396CA060ED99210ECA11C7472053B5ED4ADCF058D314569E162F2D1073670FEBFF1209F8479D5C08BC8C0F7E507C27FD6F0DB299B60A79AB7ADCA8E55A1F610439295D541CCAE993726F42B8DACE200D8DE3E1759CF57A897F9415D8696318A900A0A716E5006210BF61C73603E9359E74D06B68FE50641944F385E8D17748C901925D06FE779ADC79940BE2160E6F1E5842B173BE73CFCFFFFA930E15FA66B68E9BFF70156D2D0DD6184B6A1A34358B399865B07219725466477133795342881745F27B3057311037F67706C4C43BD0EF1FA9C26496BE40803"
window.checkout_api = "https://api2.k8s.sprinta.com.br/api2/"
// window.checkout_api = "https://sprinta.com.br/api2/"
// window.payment_api = `https://api.sprinta.com.br/payment_service/`
// window.payment_api = `https://payment-service.k8s.sprinta.com.br/`
window.payment_api = `https://payments.k8s.sprinta.com.br/`
// window.payment_api_boleto = `https://payment-service.k8s.sprinta.com.br/`
// window.payment_api_boleto = `https://payment-service.k8s.sprinta.com.br/`
window.payment_api_boleto  = `https://payments.k8s.sprinta.com.br/`
// Percentual do novo serviço para novos sorteios. Checkouts já sorteados mantêm o destino.
const pixNewServicePercent =50
const pixLegacyApi = 'https://payment-service.k8s.sprinta.com.br/'
const pixNewApi = 'https://payments.k8s.sprinta.com.br/'

const selectPixApi = () => {
  const tokenMatch = window.location.pathname.match(/^\/(?:voucher\/)?([^/]+)\/?$/)
  if (!tokenMatch) return pixLegacyApi

  const storageKey = `checkout:pix-endpoint:v1:${tokenMatch[1]}`
  try {
    const savedApi = window.localStorage.getItem(storageKey)
    if (savedApi === pixLegacyApi || savedApi === pixNewApi) return savedApi

    const selectedApi = Math.random() * 100 < pixNewServicePercent ? pixNewApi : pixLegacyApi
    window.localStorage.setItem(storageKey, selectedApi)
    return selectedApi
  } catch (error) {
    // Sem armazenamento disponível, novos carregamentos usam o serviço legado.
    return pixLegacyApi
  }
}

// Uma única escolha para criar o Pix e consultar seu status durante esta página.
window.payment_api_pix = selectPixApi()
window.payment_api_card = `https://payments.k8s.sprinta.com.br/`
// window.payment_api_card = `https://api.sprinta.com.br/payment_service/`
// window.payment_api_card = `https://api.sprinta.com.br/payment_service/`


window.link_boleto = `${window.payment_api_boleto}boleto/`
window.link_across = `${window.payment_api}pay_across/`
window.URL_ASSETS_BASE = 'https://www.sprinta.com.br/'
window.URL_BASE_OLD = 'https://www.sprinta.com.br/'
window.NOTFOUND = "https://app.sprinta.com.br/404"



// WEBPACK FOOTER //
// ./src/_config.js